import { render, staticRenderFns } from "./TemplateLayoutWithMenu.vue?vue&type=template&id=4cf7880f&scoped=true"
import script from "./TemplateLayoutWithMenu.vue?vue&type=script&lang=js"
export * from "./TemplateLayoutWithMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf7880f",
  null
  
)

export default component.exports